import { Store } from '@src/application/store/store';
import { StateDefinition } from '@src/application/store/state-definition';
import { LegacyStore } from '@src/application/store/legacy-store-interface.ts';
import Toast from '@src/application/toast';

const store = new Store({
    toasts: new StateDefinition([], false),
});

export default store as unknown as LegacyStore<Array<Toast>>;
